export const UNFINISHED_ANKETA_MODAL_TITLE = 'У вас есть незавершённая анкета';
export const UNFINISHED_ANKETA_MODAL_DESCRIPTION =
  'Можно продолжить заполнение или начать новую анкету. Предложения банков в новой анкете могут отличаться от предыдущих.';
export const UNFINISHED_ANKETA_MODAL_CONTINUE_BUTTON = 'Продолжить старую';
export const UNFINISHED_ANKETA_MODAL_START_NEW_BUTTON = 'Начать новую';
